import React from 'react';
import {
    Collapse, 
    Col, 
    Row, 
    Button, 
    Popconfirm, 
    notification, 
    TimePicker,  
    DatePicker, 
    Drawer, 
    message, 
    Select, 
    Card, 
    Popover, 
    Modal, 
    Input, 
    Checkbox, 
    InputNumber,
    Switch,
    Tag,
    Icon
} from 'antd'
import moment from 'moment';
import debounce from 'debounce';
import {
    _getDeliveriesWithFilter,
    _postLocationToOptimize, 
    _getUsersForRoute, 
    _testDeliveries,
    _postNewDeliveryMode,
    _postNewDateScheduled,
    _postCompleteLocationActionById,
    _emailAllLocationById,
    _changeProductSpecificDateScheduled,
    _postNewAddress,
    _searchScheduler,
    _createTckPickup,
    _lockLocations,
    _deleteProducts,
    _postRejectedGoods,
    _splitLocation,
    _tckEndpoint,
    _mergeLocations,
    _getSuppliers,
    _getSchedulerLogs,
    _putRemarksInternal,
    _putRemarksExternal,
    _deleteLocationById
   } from '../../services';
import { API_ENDPOINT } from '../../index';
import { connect } from 'react-redux';
import PerZoneCounter from './PerZoneCounter'
import PerDayButtonControls from './PerDayButtonControls'
import CollapsePanels from './CollapsePanels'
import TckCheckerLocationCard from './TckCheckerLocationCard'
import TckCheckerEventTimeline from './TckCheckerEventTimeline'
import ControlButtons from './ControlButtons'
import SelectSupplierModalContent from './SelectSupplierModalContent'
import SchedulerLogsDrawer from './SchedulerLogsDrawer'
const { Search } = Input;
const { RangePicker } = DatePicker;
const { Panel } = Collapse;
const { Option } = Select;
const { TextArea } = Input;

const { ORDERED_DELIVERY_MODES } = require('./config')


const openNotification = (errorInvNum, date) => {
    notification.warning({
      message: `Error: Date Change to ${moment(date).format('DD-MM-YYYY')} will cause conflicts on the following carts :`,
      description:(
        <Col>
            {errorInvNum.map(_invNum=>
                <Row key ={_invNum}>
                    <b> {_invNum} </b>
                </Row>
            )}
        </Col>
      ),
      duration: 0,
      style: {
        width: 600,
        marginLeft: 335 - 600,
      },
    });
  };



class DeliveryTable extends React.Component{
    constructor(props){
        super(props)
        this.state={

            //delivery Modes
            deliveryModes: {},
            orderedDeliveryMode:ORDERED_DELIVERY_MODES,
             //zone rules
             zoneRules: {
                Mon: ["West", "South", "Central"],
                Tue: ["North", "East", "Central"],
                Wed: ["North", "East", "Central"],
                Thu: ["West", "South" ,"Central"],
                Fri: ["North", "East", "Central"],
                Sat: ["North", "East", "Central"],
                Sun: ["North", "East", "Central"]
            },
            //count per zone
            count: [],


            //data fetch
            users: [],
            scheduledLocationData: [],
            openKeys:{}, 
            toggleShowWeekend: true,

            //suppliers
            suppliers: [],
            searchSupplier: "",
            selectedSupplier: null,
            toggleSelectSupplierModal: false,

            //possible merges
            togglePossibleMergeModal: false,
            possibleMerges: [],
            deliveryModeToMerge: null,

            // date and search controllers
            searchTerm: null,
            dateRange: [ ],

            //on select controllers
            selectedLocations: [],
            selectedLocationsData: [],

            //eezee send optimization/routing
            toggleDrawer: false,
            userId:'Select user to assign route to',
            startLocation: 'Select Starting Location',
            endLocation: 'Select Ending Location',
            route:[],

            //split on prod lvl
            togglePerProductModal: false,
            splitDate: null,
            productOrderStatusIdArray: [],

            //reject of deliveries
            toggleRejectedGoodsModal: false,
            rejectedProductsData: {},
            
            //change date of delivery
            datePickerPopover: false,
            scheduledDate: null,
            
            //show optimized mode
            toggleOptimizedRouteMode: false,

            //edit Of details
            toggleEditAddress: false,
            currentEditAddressOf: null,
            editAddress: null,
            editPostalCode: null,
            editUnit: null,
            editCompanyName: null,
            editName: null,
            editHp: null,

            //tck checker
            toggleTckCheckModal : false,
            tckTimeline: {},

            // admin logs
            toggleLogsDrawer: false,
            schedulerLogs: []
        }
        this.handleSearch = debounce(this.handleSearch,800);
        this.handleSupplierSearch = debounce(this.handleSupplierSearch, 900)
    }
    
    componentDidMount(){

        let param = new URLSearchParams(window.location.search)
        let urlStartDate = param.get("start")
        let urlEndDate = param.get("end")
        let urlSearchTerm = param.get("query")


        let start, end, search

        if(urlStartDate){
            start = urlStartDate
        }
        // else{
        //     start = moment().format('YYYY-MM-DD')
        // }

        if(urlEndDate){
            end = urlEndDate
        }
        // else{
        //     end = moment().add(4,'day').format('YYYY-MM-DD')
        // }

        if(urlSearchTerm){
            search = urlSearchTerm
        }
        
        _getUsersForRoute()
				.then(users=>{

                    setTimeout( this.hotReload, 10000 )

                    if( start && end && !search ){

                        this.setState({
                            users: users.data,
                            dateRange: [ moment(start,"YYYY-MM-DD") , moment(end,"YYYY-MM-DD") ],
                            searchTerm: null
                        }, this.refreshPage )

                    }
                    

                    if( search ){
                        this.setState({
                            users: users.data,
                            dateRange: (start && end) ? [ moment(start), moment(end) ] : [],
                            searchTerm: search
                        }, this.refreshPage )
                    }
				})

        
        
    }

    render(){
        return(
            <Col style={{marginBottom:'50px', height:'100%', overflow:'auto'}}>
                {/* DELIVERY SCHEDULER TOOLBAR */}
                <Row type="flex" justify="start" align="middle" >
                    <RangePicker format={'DD/MM/YYYY'} value={this.state.dateRange} onChange={this.onChangeDateRange} allowClear/>
                    <Search
                        placeholder = 'Inv num / buyer / company / product / address'
                        value = {this.state.searchTerm}
                        onChange={e => this.onSearch(e.target.value)}
                        style={{ width: 400 , marginLeft:'10px' }}
                    />
                    <Switch
                        checked = {this.state.toggleShowWeekend}
                        style={{ width: "95px" , marginLeft:'10px' }}
                        disabled = {this.state.searchTerm}
                        checkedChildren="Weekends"
                        unCheckedChildren="Weekends"
                        onChange={this.toggleShowWeekend}    
                    />
                </Row>

                {/* DELIVERY DASHBOARD */}
                <Row type="flex" justify="space-between">
                        {this.state.scheduledLocationData && Object.keys(this.state.scheduledLocationData).sort((a,b)=>moment(a).diff(b,"day")).map((_date, index)=>
                            <Col 
                                style={{
                                    fontSize:'16px', 
                                    width: "20vw", 
                                    textAlign:'center', 
                                    borderBottom:'1px solid black', 
                                    padding:'10px', 
                                    marginBottom:'15px'
                                }} 
                                key={_date}
                            >
                            {
                                this.state.orderedDeliveryMode.map(_deliveryMode=> {

                                    let locations = ( this.state.scheduledLocationData[_date] && this.state.scheduledLocationData[_date][_deliveryMode] ) || []
                                    let openKeys = ( this.state.openKeys[_date] && this.state.openKeys[_date][_deliveryMode] ) || []

                                    return (
                                        <Row>
                                            {_deliveryMode === "eezeeSend" &&
                                                <PerZoneCounter
                                                    countObj = {this.state.count[index]}
                                                    date = {_date}
                                                    zoneRules = {this.state.zoneRules}
                                                />
                                            }
                                            {_deliveryMode === "eezeeSend" &&
                                                <PerDayButtonControls
                                                    style={{width:"100%"}}
                                                    date = {_date}
                                                    emailAll = {this.emailAll}
                                                    createRoute = {this.createRoute}
                                                    toggleOptimizedRouteMode = {this.state.toggleOptimizedRouteMode}
                                                    selectedLocations = {this.state.selectedLocations}
                                                />
                                            }
                                            <CollapsePanels
                                                style={{width:"100%"}}
                                                zoneRules = {this.state.zoneRules}
                                                date = {_date}
                                                deliveryMode = {_deliveryMode}
                                                openKeys = { openKeys }
                                                selectedLocations = {this.state.selectedLocations}
                                                toggleShowWeekend = {this.state.toggleShowWeekend}
                                                locations = { locations }

                                                lockAll= {this.lockAll}
                                                onClickPanel = {this.onClickPanel}
                                                onSelectHandler = {this.onSelectHandler}
                                                selectAll = {this.selectAll}
                                                toggleAll = {this.toggleAll}
                                                toggleEditAddressModal = {this.toggleEditAddressModal}
                                                toggleOptimizedRouteMode = {this.state.toggleOptimizedRouteMode}

                                                onUpdateRemarksInternal={this.onUpdateRemarksInternal}
                                                onUpdateRemarksExternal={this.onUpdateRemarksExternal}
                                            />
                                        </Row>

                                    )

                                })
                            }
                            </Col>
                        )}
                        <span style={{height:"20vh", width:"100%"}} />
                </Row>

                {/* CONTROL PANEL AT THE BOTTOM */}
                <ControlButtons 
                    toggleOptimizedMode = { this.toggleOptimizedMode }
                    toggleOptimizedRouteMode = { this.state.toggleOptimizedRouteMode }

                    datePickerPopover = { this.state.datePickerPopover }
                    scheduledDate = {this.state.scheduledDate}
                    onChangeDate = { this.onChangeDate }
                    changeDateScheduled = { this.changeDateScheduled }
                    toggleDatePicker = { this.toggleDatePicker }

                    changeDeliveryMode = { this.changeDeliveryMode }

                    lockAll = { this.lockAll }

                    completeSelectedLocations = { this.completeSelectedLocations }
                    deleteSelectedLocations = { this.deleteSelectedLocations }

                    toggleRejectModal = { this.toggleRejectModal }

                    selectedLocationsData = { this.state.selectedLocationsData }
                    selectedLocations = { this.state.selectedLocations }

                    togglePerProductModal = { this.togglePerProductModal }

                    tckEndpoint = { this.tckEndpoint }

                    toggleEditAddressModal = { this.toggleEditAddressModal }

                    onToggleSelectSupplierModal = { this.onToggleSelectSupplierModal }

                    refreshPage = { this.refreshPage }

                    user = { this.props.userData.data }
                />

                <Modal
                    width="90vw"
                    title="TCK Tracker"
                    visible={this.state.toggleTckCheckModal}
                    footer = {null}
                    onCancel = {this.tckEndpoint}
                    centered = {true}
                    bodyStyle={{
                        height:"90vh",
                        overflow:"auto"
                    }}
                >
                    <Col 
                        type="flex" 
                        justify="space-between" 
                    >
                        {
                            Object.keys(this.state.tckTimeline).length > 0 &&
                            Object.keys(this.state.tckTimeline).map(_uniqueId=>
                                <Card 
                                    style={{ width: "100%", backgroundColor:"#e8e8e8", marginBottom:"15px" }}
                                    size="small" 
                                    title={
                                        <Row type="flex" justify="center" align="middle" >
                                            <Tag 
                                                style={{
                                                    fontSize:"25px"
                                                }}
                                                color="#2db7f5"
                                            >
                                                {`${this.state.tckTimeline[_uniqueId].locations[0].prettyDo}-${this.state.tckTimeline[_uniqueId].locations[0].locationActionRequired}`}
                                            </Tag>
                                        </Row>
                                    } 
                                > 
                                    <Row type="flex" justify="space-between" gutter={16} >
                                        <Col span={12} >
                                            {
                                                this.state.tckTimeline[_uniqueId].timeline.map(_event=>
                                                    <TckCheckerEventTimeline
                                                        key = { _event.CustomerReference }
                                                        event = { _event }
                                                    />
                                                )
                                            }   
                                        </Col>
                                        <Col span={12} type="flex" justify="center" align="middle" style={{height:"100%"}} >
                                            <Row>
                                                <Col type="flex" justify="space-around" align="start">
                                                    {
                                                        this.state.tckTimeline[_uniqueId].locations.map(_location=>
                                                            <TckCheckerLocationCard
                                                                key = { _location._id }   
                                                                onSelectHandler = { this.onSelectHandler }
                                                                location = { _location }
                                                                selectedLocations = { this.state.selectedLocations }
                                                            />
                                                        )
                                                    }
                                                </Col>
                                            </Row>
                                        </Col>
                                    </Row>
                                </Card>
                            )
                        }
                        <Row type="flex" justify="end" align="middle" style={{marginTop:"15px"}} >

                            <Button size="large" onClick={this.tckEndpoint} style={{marginRight:"10px"}}>
                                Cancel
                            </Button>

                            <Popconfirm
                                title="Are you sure?"
                                onConfirm={this.completeSelectedLocations}
                                okText="Yes"
                                cancelText="No"
                            >
                                <Button type="danger" size="large">
                                    Complete Selected
                                </Button>
                            </Popconfirm>
                        </Row>
                    </Col>
                    
                </Modal>
                {/* <Modal
                    title="Per Product Actions"
                    zIndex= {999}
                    width = "80vw"
                    visible={this.state.togglePerProductModal}
                    onCancel={()=>this.togglePerProductModal()}
                    footer={this.renderPerProductControl()}
                >   
                    <Col type="flex" justify="space-around">
                        {
                            this.state.selectedLocationsData.length && 
                            this.state.selectedLocationsData[0].products.map(product=>
                                <Row>
                                    <Checkbox
                                    style={{margin:"15px"}}
                                    checked = {this.state.productOrderStatusIdArray.includes(product.productOrderStatusId)}
                                    onChange={(e)=>this.onSelectPerProductLine(e,product)}
                                    >
                                        { product.productTitle }
                                    </Checkbox>
                                </Row>
                            )
                        }
                    </Col>
                </Modal> */}
                        
                
                <Modal
                zIndex = {999999999}
                title="Rejection of Products"
                visible={this.state.toggleRejectedGoodsModal}
                onCancel= {()=>this.toggleRejectModal()}
                footer={
                    <Row type="flex" justify="space-between" >
                        <Col>
                            <Button onClick={()=>this.toggleRejectModal()}>
                                Cancel
                            </Button>
                        </Col>
                        <Col>
                            <Button>
                                Reject And Void
                            </Button>
                        </Col>
                        <Col>
                            <Button onClick={()=>this.rejectAndFulfill()}>
                                Reject And Re-Fulfill
                            </Button>
                        </Col>
                    </Row>
                } 
                >
                    <Col type="flex" justify="space-between" >
                        {
                            this.state.selectedLocationsData.map(location=>
                                location.products.map((productLine, index)=>
                                    <Col type="flex" justify="space-between" style={{marginBottom:"15px"}}>
                                        <Row>
                                            <Checkbox 
                                                checked={this.state.toggleRejectedGoodsModal && this.state.rejectedProductsData[productLine.productOrderStatusId]}
                                                onChange={()=>this.selectProductForReject(productLine, index)}
                                            >
                                                {productLine.productTitle}
                                            </Checkbox>
                                        </Row>
                                        <Row style={{marginTop:"10px"}} >
                                            <div>
                                                Quantity: 
                                            </div>
                                            <InputNumber 
                                                min={1} 
                                                max={productLine.quantity} 
                                                value={this.state.toggleRejectedGoodsModal && 
                                                    this.state.rejectedProductsData[productLine.productOrderStatusId] &&
                                                    this.state.rejectedProductsData[productLine.productOrderStatusId].quantity
                                                } 
                                                onChange={ (quantity)=>this.changeProductQuantityForReject(quantity , productLine, index) } 
                                            />
                                        </Row>
                                        <Row style={{margin:"10px"}}>
                                            <TextArea 
                                            disable = {!this.state.rejectedProductsData[productLine.productOrderStatusId]}
                                            onChange={(e)=>this.rejectedReason(e, productLine)}  
                                            rows={4} 
                                            placeholder = {`Reason for rejection for ${productLine.productTitle}`}
                                            value = {this.state.toggleRejectedGoodsModal && 
                                                this.state.rejectedProductsData[productLine.productOrderStatusId] &&
                                                this.state.rejectedProductsData[productLine.productOrderStatusId].rejectedReason}
                                            />
                                        </Row>
                                    </Col>
                                )
                            )
                        }
                    </Col>
                </Modal>

                <Modal
                    title="Editing Address"
                    visible={this.state.toggleEditAddress}
                    onOk={this.onOkEditAddress}
                    onCancel={()=>this.toggleEditAddressModal()}
                >
                    <Input value={this.state.editName} onChange={this.onEditName}/>
                    <Input value={this.state.editHp} onChange={this.onEditHp}/>
                    <Input value={this.state.editCompanyName} onChange={this.onEditCompanyName}/>

                    <Input value={this.state.editAddress} onChange={this.onEditAddress}/>
                    <Input value={this.state.editPostalCode} onChange={this.onEditPostalCode}/>
                    <Input value={this.state.editUnit} onChange={this.onEditUnit}/>
                </Modal>

                <Modal
                    title="Select Supplier"
                    visible={this.state.toggleSelectSupplierModal}
                    onOk={()=>this.changeDeliveryMode("Supplier Send", this.props.selectedSupplier)} 
                    onCancel={()=>this.onToggleSelectSupplierModal()}
                    width={"700px"}
                >
                     <Row type="flex" justify="space-around" align="middle">
                        <Search
                            placeholder="Search Supplier"
                            value= { this.state.searchSupplier }
                            onChange={(e)=>this.onChangeSearchSupplier(e.target.value)}
                            style={{ width: "100%" }}
                        />
                    </Row>
                    <Row type="flex" justify="centre" align="middle" style={{width:"100%"}}>
                        <SelectSupplierModalContent 
                            suppliers = { this.state.suppliers }
                            selectedSupplier = { this.state.selectedSupplier }
                            onSelectSupplier = { this.onSelectSupplier }
                        />
                    </Row>
                </Modal>

                <Modal
                    title="Possible Merges"
                    visible={this.state.togglePossibleMergeModal}
                    centered = {true}
                    width="90vw"
                    onOk={this.mergeLocations}
                    onCancel={(e)=>this.togglePossibleMergeModal(e)}
                >
                    <Col type="flex" justify="space-between" align="middle" >
                        
                        {
                            this.state.possibleMerges.length > 0 &&
                            this.state.possibleMerges.map((_mergeArray,index)=>
                                <Card title={`Possible Merge - ${index + 1}`} style={{width:"100%", background: '#ECECEC'}}>
                                    <Row type="flex" justify="space-around" align="middle" >
                                        {
                                            _mergeArray.map( _location =>
                                                <Col>
                                                    <Card title={`${_location.invNum}`} style={{maxWidth:"450px", minWidth:"300px"}}>
                                                        <Col type="flex" justify="space-around" align="start" >
                                                            <Row>
                                                                { _location.locationActionRequired }
                                                            </Row>
                                                            <Row>
                                                                { _location.deliveryMode }
                                                            </Row>
                                                            <Row style={{marginTop:"10px"}} >
                                                                { _location.address.companyName }
                                                            </Row>
                                                            <Row>
                                                                { _location.address.name }
                                                            </Row>
                                                            <Row style={{marginBottom:"10px"}} >
                                                                { _location.address.address }
                                                            </Row>
                                                            {
                                                                _location.products.map(_product=>
                                                                    <Row>
                                                                        { `${_product.productTitle} x ${_product.quantity}` }
                                                                    </Row>
                                                                )
                                                            }
                                                        </Col>
                                                    </Card>
                                                </Col>
                                            )
                                        }
                                    </Row>
                                </Card>
                            )
                        }
                        
                    </Col>
                </Modal>

                <Drawer
                title="Route Optimisation For Eezee Send"
                placement='left'
                visible={this.state.toggleDrawer}
                closable={false}
                onClose={()=>{this.setState({toggleDrawer: false, startLocation:'Select Starting Location', endLocation:'Select Ending Location'})}}
                width='50vw'
                >
                    <Row>
                        <Select 
                        value={this.state.userId}
                        size='large'
                        style={{width: '100%' , border:'#000000d9 solid 3px', borderRadius:'7px', marginBottom:'5px'}} 
                        onChange={(value)=>this.selectUser(value)}
                        >
                            {this.state.users.length > 0 && 
                                this.state.users.map(_user=> 
                                    <Option key={_user._id} value={_user._id}>{_user.details.name}</Option>)
                            }
                        </Select>
					</Row>
                    <Row>
                        <Select 
                        value={this.state.startLocation}
                        size='large'
                        style={{width: '100%' , border:'#000000d9 solid 3px', borderRadius:'7px', marginBottom:'5px'}} 
                        onChange={(value)=>this.changeStartLocation(value)}
                        >
                            <Option value="eezee">Eezee</Option>
                            <Option value="driverAddress">
                                Uncle's Address: 683 Hougang Ave 8 530681
                            </Option>
                        </Select>
					</Row>
                    <Row>
                        <Select 
                        value={this.state.endLocation}
                        size='large'
                        style={{ width: '100%', border:'#000000d9 solid 3px', borderRadius:'7px', marginBottom:'5px' }} 
                        onChange={(value)=>this.changeEndLocation(value)}
                        >
                            <Option value="eezee">Eezee</Option>
                            <Option value="driverAddress">
                                    Uncle's Address: 683 Hougang Ave 8 530681
                            </Option>
                        </Select>
				    </Row>
                    <Row>
                        {this.state.route.length > 0 && this.state.route.map(_location=>
                            <Card size="small" title={_location.address.address}  style={{ width: '30vw', marginLeft: '30px', marginBottom:'20px' }} key={_location._id}>
                                <Col gutter={16}>
                                    <Row span={4} >
                                        <b>{_location.cartId && `${_location.invNum} ${_location.locationActionRequired}`}</b>
                                    </Row>
                                    <Row span={4} >
                                        <b>{ _location.address.companyName ? _location.address.companyName : _location.address.name }</b>
                                    </Row>
                                    <Row span={4} >
                                        <b>{_location.cartId && 'Products'}</b>
                                    </Row>
                                    <Row span={4} >
                                        {_location.cartId && _location.products.map(_product=><p key={_product.productTitle}>{`${_product.productTitle} x${_product.quantity}`}</p>)}
                                    </Row>
                                    {/* {_location.cartId &&
                                    <Row type="flex" justify="start">
                                        <Col span={10}> 
                                            <TimePicker 
                                                placeholder='From'
                                                format={'HH:mm'}
                                                // style={{width:'25px'}}
                                                onChange={(value)=>this.changeDestinationFromTime(value, _location.deliveryLocationId)}/>
                                        </Col>
                                        <Col span={10}> 
                                            <TimePicker
                                                placeholder='To' 
                                                format={'HH:mm'}
                                                // style={{width:'25px'}}
                                                onChange={(value)=>this.changeDestinationToTime(value, _location.deliveryLocationId)}/>
                                        </Col>
							        </Row>} */}
                                </Col>
                            </Card>
                        )}
                    </Row>
                    <Button style={{position:'fixed', bottom:'5px', left:'15px', zIndex:'3'}} type='primary' size='large' onClick={()=>this.optimizeRoute()}>
                        Optimize
                    </Button>
                </Drawer>

                
                
                
                    <SchedulerLogsDrawer/>
                
                

                <span></span>
            </Col>
        )
    }

    renderDatePromised = (_location) => {
        let workingDays = {
            standard: 5,
            express: 3
        }
        let numOfWorkingDays = 0
        let promisedDate = moment(_location.datePurchased, 'DD/MM/YY')
        while(numOfWorkingDays < workingDays[_location.deliveryOption]){
            let day = moment(promisedDate).add(1,'day').format('ddd')
            promisedDate = moment(promisedDate).add(1,'day')
            if(day === "Sat" || day ==="Sun"){
                continue
            }else{
                numOfWorkingDays = numOfWorkingDays + 1
            }
        }

        return(
            <Row style={{borderBottom:'0.5px solid #d9d9d9', paddingTop:'10px'}} span={4}>
                Promised Delivery Date: <b>{moment(promisedDate).format('DD/MM/YY')}</b>
            </Row>
        )
    }

    renderPerProductControl = () => {
        let renderButton = (deliveryMode, key) => {
            let dict = {
                eezeeSend: "Eezee Send",
                tckExpress: "TCK Express",
                supplierSend: "Supplier Send",
                janio: "Janio",
                lalamove: "Lalamove"
            }
            let disabled = (this.state.selectedLocationsData.length>0 && 
                ( 
                    this.state.selectedLocationsData[0].products.length === this.state.productOrderStatusIdArray.length 
                ) 
                ||
                ( 
                    this.state.productOrderStatusIdArray.length===0 
                ) 
                || 
                (
                    this.state.selectedLocationsData[0].deliveryMode === `${dict[deliveryMode]}` && 
                    moment(this.state.selectedLocationsData[0].dateScheduled).format("YYYY-MM-DD") === moment(this.state.splitDate).format("YYYY-MM-DD") 
                ) 
            )
            
            return(
                <Col key={key}>
                {
                    <Popconfirm
                    style={{zIndex:9999}}
                    title="Are you sure?"
                    onConfirm={(e)=>this.splitLocation(e, deliveryMode)}
                    okText= {`SPLIT TO ${dict[deliveryMode]}`}
                    cancelText="No"
                    >
                        <Button 
                            disabled={disabled}
                            style={{margin:"5px"}} 
                            type="primary" 
                            size='large' 
                        >
                            {`Split to ${dict[deliveryMode]}`} 
                        </Button>
                    </Popconfirm>
                }
                </Col>
            )
        }
        

        return(
            <Col style={{width:"100%"}} type="flex" justify="space-around">
                <Row type="flex" justify="center">
                    <DatePicker
                        disabled = {this.state.selectedLocationsData.length>0 && this.state.selectedLocationsData[0].products.length === this.state.productOrderStatusIdArray.length}
                        size="large"
                        format="DD/MM/YYYY"
                        placeholder="Select Date and Time"
                        style={{margin:"10px"}}
                        value = {this.state.splitDate}
                        onChange = {this.perProductDateChange}
                    />
                </Row>
                <Row type="flex" justify="space-around">
                    {
                        this.props.userData.data.permissions.ezTech &&
                            <Popconfirm
                                style={{zIndex:9999999}}
                                title="Are you sure?"
                                onConfirm={()=>this.deleteDelivery()}
                                okText="DELETE DELIVERY"
                                cancelText="No"
                            >
                                <Button 
                                    style={{margin:"5px"}} 
                                    type="danger" 
                                    size='large' 
                                >
                                    Delete Delivery
                                </Button>
                            </Popconfirm>
                    }
                    

                    {
                        Object.keys(this.state.deliveryModes).length > 0 &&
                        Object.keys(this.state.deliveryModes).map((_deliveryMode, i)=>
                            renderButton(_deliveryMode, i)
                        )
                    }

                </Row>
            </Col>
        )
    }

    generateMaxDeliveryDate = (_location) => {
        let workingDays = {
            standard: 5,
            express: 3
        }

        let maxDeliveryDate = moment(_location.datePurchased, 'DD/MM/YY')
        let numOfWorkingDays = 0
       
        while(numOfWorkingDays < workingDays[_location.deliveryOption]){
            let day = moment(maxDeliveryDate).add(1,'day').format('ddd')
            maxDeliveryDate = moment(maxDeliveryDate).add(1,'day')
            if(day === "Sat" || day ==="Sun"){
                continue
            }else{
                numOfWorkingDays = numOfWorkingDays + 1
            }
        }
        return(maxDeliveryDate)
    }    

    selectProductForReject = (product, i) => {
        let  rejectedProductsData = {...this.state.rejectedProductsData}

        if(Object.keys(rejectedProductsData).includes(product.productOrderStatusId)){
            delete rejectedProductsData[product.productOrderStatusId]
        }else{
            rejectedProductsData[product.productOrderStatusId] = {
                quantity: product.quantity,
                rejectedReason: ""
            }
        }

        this.setState({
            rejectedProductsData: rejectedProductsData,
            selectedLocations: []
        })

    }

    tckEndpoint = () => {
        
       
        if(!this.state.toggleTckCheckModal){
            message.loading("Loading TCK Event List", 0)
            _tckEndpoint( this.state.selectedLocations )
            .then(res=>{
                message.destroy()
                message.success("Suucess")
                this.setState({
                    selectedLocations: [],
                    selectedLocationsData: [],
                    toggleTckCheckModal : true,
                    tckTimeline: res.data
                })
            })
            .catch(e=>{
                message.destroy()
                message.error("Error")
                console.log(e)
            })
        }else{
            this.setState({
                toggleTckCheckModal : false
            }, this.refreshPage)
        }
        

            
    }

    toggleRejectModal = () => {
        let error = false
        if(this.state.selectedLocationsData.length === 1 && this.state.selectedLocationsData[0].locationActionRequired === "delivery" && !this.state.toggleRejectedGoodsModal){

            let products = this.state.selectedLocationsData[0].products
            let rejectedProductsData = {}
            products.forEach((productLine, i)=>{

                if(!productLine.productOrderStatusId){
                    error = true
                }else{
                    rejectedProductsData[productLine.productOrderStatusId] = {
                        quantity: productLine.quantity,
                        rejectedReason: ""
                    }
                }
            })

            if(error){
                message.error("Error. Product dont have order status ID")
            }else{
                this.setState({
                    toggleRejectedGoodsModal: true,
                    rejectedProductsData: rejectedProductsData
                })
            }
        }

        if(this.state.toggleRejectedGoodsModal){
            this.setState({
                toggleRejectedGoodsModal: false,
                rejectedProductsData: {},
                selectedLocations: [],
                selectedLocationsData: []
            })
        }

        if( this.state.selectedLocationsData.length != 1 || this.state.selectedLocationsData[0].locationActionRequired != "delivery" ){
            message.error("Please select only 1 Delivery Location for rejection")
        }
        
    }

    changeProductQuantityForReject = (quantity, product, i) => {

        let  rejectedProductsData = {...this.state.rejectedProductsData}
       
        rejectedProductsData[product.productOrderStatusId].quantity = quantity

        this.setState({
            rejectedProductsData: rejectedProductsData
        })
    }

    rejectedReason = (e , product) => {
        
        let  rejectedProductsData = {...this.state.rejectedProductsData}
       
        rejectedProductsData[product.productOrderStatusId].rejectedReason = e.target.value

        this.setState({
            rejectedProductsData: rejectedProductsData
        })
    }
    
    rejectAndFulfill = () => {
        let rejectedGoods = []
        let rejectedProductsData = {...this.state.rejectedProductsData}
        let deliveryLocationId = this.state.selectedLocationsData[0]._id
        Object.keys(rejectedProductsData).map(productOrderStatusId=>{
            let container = {}
            let quantity = rejectedProductsData[productOrderStatusId].quantity
            let reason = rejectedProductsData[productOrderStatusId].rejectedReason

            container = {
                productOrderStatusId:  productOrderStatusId,
                quantity: quantity,
                rejectedReason: reason
            }

            rejectedGoods.push(container)
        })
        _postRejectedGoods({
            rejectedGoods,
            deliveryLocationId
        })
        .then(()=>{
            this.refreshPage()
        })
    }

    changeDeliveryMode = (deliveryMode) => {

        console.log({deliveryMode})

        if(deliveryMode === "Supplier Send" && !this.state.selectedSupplier ){
            message.error("select a supplier")
        }else{
            _postNewDeliveryMode(deliveryMode, this.state.selectedLocations, this.state.selectedSupplier, this.props.userData.data.details.name,this.props.userData.data.details.email,this.props.userData.data._id)
            .then(res=>{
                if(res.data.status === "success"){
                    this.refreshPage() 
                }
                if(res.data.status === "possible merge"){
                    this.setState({
                        deliveryModeToMerge: deliveryMode,
                        togglePossibleMergeModal: true,
                        possibleMerges: res.data.possibleMerges
                    })
                }
            })
        }

    }
    changeDateScheduled = () => {
        _postNewDateScheduled(
            moment(this.state.scheduledDate).format("YYYY-MM-DD"), 
            this.state.selectedLocations,
            this.props.userData.data.details.name,
            this.props.userData.data._id,
            this.props.userData.data.details.email
        )
        .then(res=>{
            if(res.data.status === "failure"){
                openNotification(res.data.info, this.state.scheduledDate)
                this.setState({
                    datePickerPopover: false
                })
            }
            if(res.data.status === "success"){
                this.refreshPage() 
            }
            if(res.data.status === "possible merge"){
                this.setState({
                    togglePossibleMergeModal: true,
                    possibleMerges: res.data.possibleMerges,
                    datePickerPopover: false
                })
            }
        })
        .catch(e=>console.log(e))
    }
    togglePossibleMergeModal = (e) => {
        e.preventDefault()
        this.setState({
            togglePossibleMergeModal: !this.state.togglePossibleMergeModal,
            possibleMerges: []
        })
    }
    mergeLocations = () => {

        message.loading("Merging...")
        this.setState({
            togglePossibleMergeModal: false,
        }, () => {
            _mergeLocations({
                possibleMerges: this.state.possibleMerges,
                dateToChange: this.state.scheduledDate,
                deliveryModeToChange: this.state.deliveryModeToMerge,
                userName: this.props.userData.data.details.name,
                userEmail: this.props.userData.data._id,
                userId: this.props.userData.data.details.email
            })
            .then(()=>{
                this.refreshPage()
            })
        })

    }
    emailAll = (e , _date) => {
        e.preventDefault()
        let locationsToEmail = {}
        let date = moment(_date).format('YYYY-MM-DD')
            
            Object.keys(this.state.scheduledLocationData[_date]).map(deliveryMode=>{
                if(deliveryMode != "janio"){
                    if(!locationsToEmail[deliveryMode]){
                        locationsToEmail[deliveryMode] = {}
                    }
                    if(!locationsToEmail[deliveryMode][date]){
                        locationsToEmail[deliveryMode][date] = []
                    }
                    
                    let container = []

                    this.state.scheduledLocationData[_date][deliveryMode].forEach(_loc=>{
                        if( _loc.plannedForRoute && !_loc.dateCompleted && !_loc.emailSent ){
                            container.push(_loc._id)
                        }
                    })
                    locationsToEmail[deliveryMode][date] = container
                }
            })
        message.loading('Emailing', 0)
            _emailAllLocationById({
                locationsToEmail: locationsToEmail,
                userName: this.props.userData.data.details.name,
                userEmail: this.props.userData.data.details.email,
                userId: this.props.userData.data._id,
            })
                .then(()=>{
                    message.destroy()
                    message.success("Email sent")
                    this.refreshPage() 
                })
                .catch(e=>console.log(e))
    }
    onChangeDate = (value) => {
        this.setState({
            scheduledDate: value
        })
    }
    onChangeDateRange = (value) => {

        if (value.length == 0) {
            this.setState({
                dateRange: [],
            }, this.refreshPage )
            return;
        }

        this.setState({
            dateRange: [moment(value[0]), moment(value[1])],
        }, this.refreshPage )
    }
    onSelectHandler = (location , id, e)=>{
        e.stopPropagation()
           
            let selectedLocations = [...this.state.selectedLocations]
            let selectedLocationsData = [...this.state.selectedLocationsData]

            if(selectedLocations.includes(id)){
                selectedLocations = selectedLocations.filter(_id=>_id!=id)
                selectedLocationsData = selectedLocationsData.filter(data=>data._id != id)
            }else{
                selectedLocations.push(id)
                selectedLocationsData.push(location)
            }

            console.log({selectedLocations, selectedLocationsData})
            this.setState({
                selectedLocations: selectedLocations,
                selectedLocationsData: selectedLocationsData
            })
    }
    onSelectPerProductLine = (e,product) => {
        e.preventDefault()
        let selectedProductOrderStatusIdArray = [...this.state.productOrderStatusIdArray]
        let productOrderStatusId = product.productOrderStatusId
        if(!productOrderStatusId){
            message.error("Product does not have order status ID")
        }else{

            if(selectedProductOrderStatusIdArray.includes(productOrderStatusId)){
                selectedProductOrderStatusIdArray = selectedProductOrderStatusIdArray.filter(id=>id!=productOrderStatusId)
            }else{
                selectedProductOrderStatusIdArray.push(productOrderStatusId)
            }
            this.setState({
                productOrderStatusIdArray: selectedProductOrderStatusIdArray
            })
        }

    }
    selectAll = (date, deliveryMode) => {
        let totalIdArray = []
        let totalLocations = []

        let existingSelectedLocations = [...this.state.selectedLocations]
        let exisitingSelectedData = [...this.state.selectedLocationsData]

        this.state.scheduledLocationData[date][deliveryMode].forEach(_loc=>{
            if(!_loc.dateCompleted){
                totalIdArray.push(_loc._id)
                totalLocations.push(_loc)
            }
        })

        let checker = totalIdArray.every(_id => existingSelectedLocations.includes(_id))
        
        if(checker){
            existingSelectedLocations = existingSelectedLocations.filter(_id=>!totalIdArray.includes(_id))
            exisitingSelectedData = exisitingSelectedData.filter(_loc=>!totalIdArray.includes(_loc._id))
        }else{
            existingSelectedLocations = existingSelectedLocations.concat(totalIdArray)
            existingSelectedLocations = existingSelectedLocations.filter((_id,index,self)=>index === self.indexOf(_id))

            exisitingSelectedData = exisitingSelectedData.concat(totalLocations)
            exisitingSelectedData = exisitingSelectedData.filter((_loc,index,self)=>index === self.findIndex( x => x._id === _loc._id ))
        }

        this.setState({
            selectedLocations: existingSelectedLocations,
            selectedLocationsData: exisitingSelectedData
        })
    }
    lockAll = ( date , deliveryMode, individualMark ) => {

        let locationIds = []

        if(!individualMark){
            this.state.scheduledLocationData[date][deliveryMode].map(_location =>{ 
                if(!_location.plannedForRoute && !_location.dateCompleted){
                    locationIds.push(_location._id) 
                }
            })
        }else{
            let eezeeOnly = []
            let idContainer = []
            this.state.selectedLocationsData.map(loc=>{
                if(loc.deliveryMode === "Eezee Send"){
                    eezeeOnly.push(loc._id)
                }
                if(!loc.dateCompleted && !loc.plannedForRoute ){
                    idContainer.push(loc._id)
                }
            })
            locationIds = idContainer
        }
        
        if(locationIds.length > 0){
            message.loading(`Tagging ${locationIds.length} locations`)
            _lockLocations(locationIds, this.props.userData.data.details.name,this.props.userData.data.details.email,this.props.userData.data._id )
                .then(()=>{
                    message.destroy()
                    this.refreshPage()
                })
                .catch(e=>console.log(e))
        }

    }
    createRoute = (date) => {
        let locationArray = []
        this.state.scheduledLocationData[date]["eezeeSend"].map(_location=>{
            if(!_location.dateCompleted || _location.dateCompleted === null){
                locationArray.push(_location)
            }
        })
        // let formatedDate = moment(date).format('YYYY-MM-DD')
        if(locationArray.length > 48){
            message.error(`Too many Eezee Send Locations. Please reschedule at least ${locationArray.length - 48} locations`)
        }else{
            
            this.setState({
                route: locationArray,
                toggleDrawer: true,
                selectedLocations: [],
                selectedLocationsData: []
            })
        }
    }

    selectUser = (value) => {
        this.setState({
            userId: value
        })
    }

    changeStartLocation = (value) => {
        let startLocation
        const driverAddress = {
            address : {
                startOrEnd: true,
                postalCode : "530681",
                address : "683 Hougang Ave 8"
            }
        }
        const eezeeAddress = {
            address: {
                startOrEnd: true,
                name: "Eezee",
                address: "Block 4010 Ang Mo Kio Techplace 1, Avenue 10, #04-03",
                postalCode: "569626"
            }
        }

        if(value === "eezee"){
            startLocation = eezeeAddress
        }
        if(value === "driverAddress"){
            startLocation = driverAddress
        }
       
        let route = [...this.state.route]

        if(!route[0].address.startOrEnd){
            route.unshift(startLocation)
        }else{
            route.splice( 0 , 1, startLocation )
        }
        
        this.setState({
            startLocation: startLocation.address.address,
            route: route
        })
    }
   
    changeEndLocation = (value) => {
        let startLocation, endLocation
        const driverAddress = {
            
            address : {
                id: "END",
                name : "Uncle",
                postalCode : "530681",
                address : "683 Hougang Ave 8"
            }
        }
        const eezeeAddress = {
            address: {
                id: "END",
                name: "Eezee",
                address: "Block 4010 Ang Mo Kio Techplace 1, Avenue 10, #04-03",
                postalCode: "569626"
            }
        }

        if(value === "eezee"){
            endLocation = eezeeAddress
        }
        if(value === "driverAddress"){
            endLocation = driverAddress
        }
       
        let route = [...this.state.route]
        if(!route[ route.length - 1 ].address.startOrEnd){
            route.push(endLocation)
        }else{
            route.splice( route.length - 1 , 1, endLocation )
        }
        this.setState({
            endLocation: endLocation.address.address,
            route: route
        })
    }

    completeSelectedLocations = () => {
        message.loading('completing...', 0)
        
        let locationIdArray  = [...this.state.selectedLocations]
       
		_postCompleteLocationActionById(locationIdArray, this.props.userData.data.details.name, this.props.userData.data.details.email, this.props.userData.data._id)
			.then(()=>{
                message.destroy()
                message.success("Completed")
                this.refreshPage() 
            })
            .catch(e=>console.log(e))
    }
    deleteSelectedLocations = () => {
        message.loading('completing...', 0)
        
        const locationId = this.state.selectedLocations[0];
        console.log({ locationId })

        _deleteLocationById(locationId)
			.then(()=>{
                message.destroy()
                message.success("Deleted")
                this.refreshPage() 
            })
            .catch(e=>console.log(e))
    }
    onSearch = (searchString) => {

        this.setState({
            toggleShowWeekend: true,
            searchTerm: searchString.trim().length > 0 ? searchString : ""
        }, this.refreshPage )
        
    }

    onEditName= (value) => {
        this.setState({
            editName : value.target.value
        })
    }
    onEditHp= (value) => {
        this.setState({
            editHp : value.target.value
        })
    }
    onEditCompanyName= (value) => {
        this.setState({
            editCompanyName : value.target.value
        })
    }
    onEditAddress= (value) => {
        this.setState({
            editAddress : value.target.value
        })
    }
    onEditPostalCode= (value) => {
            this.setState({
                editPostalCode : value.target.value
            })
    }
    onEditUnit= (value) => {
        this.setState({
            editUnit : value.target.value
        })
    }
    onOkEditAddress = () => {
        _postNewAddress({
            locationId: this.state.currentEditAddressOf,
            companyName: this.state.editCompanyName,
            name: this.state.editName,
            hp: this.state.editHp,
            address: this.state.editAddress,
            postalCode: this.state.editPostalCode,
            unit: this.state.editUnit,
            userName: this.props.userData.data.details.name,
            userEmail: this.props.userData.data.details.email,
            userId: this.props.userData.data._id,
        })
        .then((updatedLocation)=>{
            message.success(`${updatedLocation.data.invNum} ${updatedLocation.data.locationActionRequired} at ${updatedLocation.data.address.zone} scheduled on ${moment(updatedLocation.data.dateScheduled).format('YYYY-MM-DD')}`, 10 )
            this.refreshPage() 
        })
        .catch(e=>{
            message.error('error has occured')
            console.log(e)
        })
    }
    onUpdateRemarksInternal = (locationId, remarks) => {
        _putRemarksInternal({
            deliveryId: locationId, 
            remarks: remarks
        })
        .then(() => {
            this.refreshPage()
        })
    }
    onUpdateRemarksExternal = (locationId, remarks) => {
        _putRemarksExternal({
            deliveryId: locationId, 
            remarks: remarks
        })
        .then(() => {
            this.refreshPage()
        })
    }


    deleteDelivery = () => {
        _deleteProducts({
            locationId: this.state.selectedLocationsData[0]._id,
            productOrderStatusIdArray: this.state.productOrderStatusIdArray,
            deleteWhole: this.state.selectedLocationsData[0].products.length === this.state.productOrderStatusIdArray.length
        })
        .then(()=>{
            this.refreshPage() 
        })
    }

    optimizeRoute = () => {
        message.loading('Optimizing... Please wait', 0)
        
        let ids = this.state.route.map(location=>{
            if(location._id){
                return( location._id )
            }else{
                return( location )
            }
        })
			_postLocationToOptimize({
                locationIds: ids, 
                driverId: this.state.userId,
                routeDate: moment(this.state.route[1].dateScheduled).format("YYYY-MM-DD"),
                userName: this.props.userData.data.details.name,
                userEmail: this.props.userData.data.details.email,
                userId: this.props.userData.data._id,
            })
			.then((res)=>{
                if(res.data.status === "success"){
                    message.destroy()
                    message.success("optimized")
                    this.refreshPage() 
                }
                if(res.data.status === "failure"){
                  
                    message.destroy()
                    res.data.data.map(pc=>message.error(`Error on postal code: ${pc}`, 30))
                }
            })
            .catch(e=>console.log(e))
    }
    
    perProductDateChange = (date) => {
        this.setState({
            splitDate: date
        })
    }

    splitLocation = (e, deliveryMode) => {
        e.preventDefault()
        message.loading(`Splitting to ${this.state.deliveryModes[deliveryMode]}`)
        _splitLocation({
            productOrderStatusIdArray: this.state.productOrderStatusIdArray,
            deliveryLocationId: this.state.selectedLocationsData[0]._id,
    
            dateToChange: moment(this.state.splitDate).format("YYYY-MM-DD"),
            deliveryModeToChange: this.state.deliveryModes[deliveryMode]
        })
        .then(()=>{
            this.refreshPage() 
        })
        .catch(e=>{
            message.error('error has occured')
            console.log(e)
        })
    }
    togglePerProductModal = () => {
        this.setState({
            togglePerProductModal: !this.state.togglePerProductModal,
            splitDate: this.state.selectedLocationsData[0].dateScheduled ? 
                moment(this.state.selectedLocationsData[0].dateScheduled) : 
                null
        })
    }
    toggleEditAddressModal = (_id , location) => {

        if(this.state.toggleEditAddress){
            this.setState({
                toggleEditAddress: !this.state.toggleEditAddress,
                currentEditAddressOf: null,
                editCompanyName: null,
                editName: null,
                editHp:  null,
                editAddress: null,
                editPostalCode: null,
                editUnit: null
            })
        }else{
            let { 
                companyName, 
                name, 
                hp, 
                address, 
                postalCode, 
                unit
            } = location
            this.setState({
                toggleEditAddress: !this.state.toggleEditAddress,
                currentEditAddressOf: this.state.currentEditAddressOf ? null : _id,
                editCompanyName: this.state.editCompanyName ? null : companyName,
                editName: this.state.editName ? null : name,
                editHp: this.state.editHp ? null : hp,
                editAddress: this.state.editAddress ? null : address,
                editPostalCode: this.state.editPostalCode ? null : postalCode,
                editUnit: this.state.editUnit ? null : unit
            })
        }
    }
    toggleDatePicker = (e) => {
        e.preventDefault()
        this.setState({
            datePickerPopover: !this.state.datePickerPopover
        })
    }
    toggleAll = (date, deliveryMode) => {
        let openKeys = {...this.state.openKeys}
        if( openKeys[date][deliveryMode].length === this.state.scheduledLocationData[date][deliveryMode].length){
            openKeys[date][deliveryMode] = []
            this.setState({
                openKeys: openKeys
            })
        }else{
            openKeys[date][deliveryMode] = this.state.scheduledLocationData[date][deliveryMode].map(_location => _location._id)
            this.setState({
                openKeys: openKeys
            })
        }
        
        
    }
    
    toggleShowWeekend = () => {
        this.setState({
            toggleShowWeekend: !this.state.toggleShowWeekend
        }, this.refreshPage)
    }
    
    toggleOptimizedMode = () => {
        
        let scheduledLocationData = {...this.state.scheduledLocationData}
        if(!this.state.toggleOptimizedRouteMode){
            Object.keys(scheduledLocationData).map((date,i)=>{
                scheduledLocationData[date].eezeeSend = scheduledLocationData[date].eezeeSend.sort((a,b)=>{
                    if( !a.route ){
                        a.route = {
                            optimizedRank: 0
                        }
                    };

                    if(!a.route.optimizedRank){
                        a.route.optimizedRank = 0
                    }

                    if( !b.route ){
                        b.route = {
                            optimizedRank: 0
                        };
                    }

                    if(!b.route.optimizedRank){
                        b.route.optimizedRank = 0
                    }
                    return(a.route.optimizedRank-b.route.optimizedRank)
                })
            })
        }else{
            Object.keys(scheduledLocationData).map((date,i)=>{
                scheduledLocationData[date].eezeeSend = scheduledLocationData[date].eezeeSend.sort((a,b)=>{
                    return(a.invNum.localeCompare(b.invNum))
                })
            })
        }
        this.setState({
            toggleOptimizedRouteMode: !this.state.toggleOptimizedRouteMode,
            scheduledLocationData: scheduledLocationData,
            selectedLocations: []
        })
    }
    onClickPanel = (idArray,deliveryMode,date) => {

        let openKeys = {...this.state.openKeys}
        openKeys[date][deliveryMode] = idArray

        this.setState({
            openKeys: openKeys
        })
    }

    generateAllDeliveryModes = (deliveries) => {
        let deliveryModes = {
            "eezeeSend": "Eezee Send",
            "tckExpress": "TCK Express",
            "supplierSend": "Supplier Send",
            "janio": "Janio",
            "lalamove": "Lalamove"
        }
        
        return deliveryModes
    }

    generateOpenKeys = (deliveries) => {

        let shallowCopyOpenKeys =  Object.keys(this.state.openKeys).length > 0 ? {...this.state.openKeys} : null
        let openKeys = {}
        Object.keys(deliveries).forEach(_date=>{
            if(!openKeys[_date]){
                openKeys[_date] = {}
            }
            Object.keys(deliveries[_date]).map(_deliveryMode=>{
                if(!openKeys[_date][_deliveryMode]){
                    openKeys[_date][_deliveryMode] = []
                    if( shallowCopyOpenKeys && shallowCopyOpenKeys[_date] && shallowCopyOpenKeys[_date][_deliveryMode] ){
                        openKeys[_date][_deliveryMode] = shallowCopyOpenKeys[_date][_deliveryMode]
                    }
                }
            })
        })

        return openKeys
    }

    refreshPage = () => {

        let stateRefresh = {

            selectedLocations: [],
            selectedLocationsData: [],

            toggleDrawer: false,
            userId:'Select user to assign route to',
            startLocation: 'Select Starting Location',
            endLocation: 'Select Ending Location',
            route:[],

            togglePerProductModal: false,
            splitDate: null,
            productOrderStatusIdArray: [],

            datePickerPopover: false,
            scheduledDate: null,

            toggleOptimizedRouteMode: false,

            toggleRejectedGoodsModal: false,
            rejectedProductsData: {},
            
            toggleEditAddress: false,
            currentEditAddressOf: null,
            editAddress: null,
            editPostalCode: null,
            editUnit: null,
            editCompanyName: null,
            editName: null,
            editHp: null,

            toggleTckCheckModal: false,

            togglePossibleMergeModal: false,
            possibleMerges: [],
            deliveryModeToMerge: null,

            toggleSelectSupplierModal: false,
            suppliers: [],
            selectedSupplier: null,
            searchSupplier: ""
        }

        if(this.state.searchTerm){
           this.handleSearch(stateRefresh)
        }else{
            
            let [startDate, endDate] = this.state.dateRange
            let start = startDate ? moment(startDate).format('YYYY-MM-DD') : null
            let end = endDate ? moment(endDate).format('YYYY-MM-DD') : null
    
            _searchScheduler({
                search: this.state.searchTerm ? this.state.searchTerm.toString() : "",
                start,
                end,
                showWeekends: this.state.toggleShowWeekend
            })
            .then(res=>{

                // if (startDate && endDate) {
                //     window.history.pushState(null,null,`?start=${start}&end=${end}`, '');
                // }

                const openKeys = this.generateOpenKeys(res.data)
                const count = this.sectorCounter(res.data)
                const deliveryModes = this.generateAllDeliveryModes(res.data)
                
                stateRefresh["openKeys"] = openKeys
                stateRefresh["scheduledLocationData"] = res.data
                stateRefresh["count"] = count
                stateRefresh["dateRange"] = [startDate, endDate]
                stateRefresh["deliveryModes"] = deliveryModes

                this.setState( stateRefresh )
            })
        }
    }

    onToggleSelectSupplierModal = () => {
        if(this.state.toggleSelectSupplierModal){
            this.refreshPage()
        }else{
            this.setState({
                toggleSelectSupplierModal: true
            })
        }
    }

    onChangeSearchSupplier = (searchTerm) => {
        this.setState({
            searchSupplier: searchTerm
        }, this.handleSupplierSearch)
    }
    onSelectSupplier = (id) => {
        let selected
        if(id === this.state.selectedSupplier){
            selected = null
        }else{
            selected = id
        }
        this.setState({
            selectedSupplier: selected
        })
    }
    handleSupplierSearch = () => {
        _getSuppliers({
            searchTerm: this.state.searchSupplier
        })
        .then(res=>{
            this.setState({
                suppliers: res.data
            })
        })
    }

    handleSearch = (stateRefresh) => {

        let [startDate, endDate] = this.state.dateRange
        let start = startDate ? moment(startDate).format('YYYY-MM-DD') : null
        let end = endDate ? moment(endDate).format('YYYY-MM-DD') : null

        _searchScheduler({
            search: this.state.searchTerm ? this.state.searchTerm.toString() : "",
            start,
            end,
            showWeekends: this.state.toggleShowWeekend
        })
        .then(deliveries=>{
            window.history.pushState(null,null,`?query=${this.state.searchTerm}`, '');
            message.destroy()

            const openKeys = this.generateOpenKeys(deliveries.data)
            const count = this.sectorCounter(deliveries.data)
            const deliveryModes = this.generateAllDeliveryModes(deliveries.data)

            stateRefresh["deliveryModes"] = deliveryModes
            stateRefresh["openKeys"] = openKeys
            stateRefresh["scheduledLocationData"] = deliveries.data
            stateRefresh["count"] = count
            stateRefresh["toggleShowWeekend"] = true

            this.setState( stateRefresh )
        })
    }

    sectorCounter = (locationObject) => {

        let counter = []

        Object.keys(locationObject).map((date,index)=>{
            
            let eastP = 0,
                centralP = 0,
                southP = 0,
                northP = 0,
                westP = 0,

                eastD = 0,
                centralD = 0,
                southD = 0,
                northD = 0,
                westD = 0

            locationObject[date].eezeeSend.map((_location)=>{
                if(_location.address.zone === 'East'){
                    if(_location.locationActionRequired === 'pickup'){
                        eastP = eastP + 1
                    }
                    if(_location.locationActionRequired === 'delivery'){
                        eastD = eastD + 1
                    }
                }
                if(_location.address.zone === 'Central'){
                    if(_location.locationActionRequired === 'pickup'){
                        centralP = centralP + 1
                    }
                    if(_location.locationActionRequired === 'delivery'){
                        centralD = centralD + 1
                    }
                }
                if(_location.address.zone === 'South'){
                    if(_location.locationActionRequired === 'pickup'){
                        southP = southP + 1
                    }
                    if(_location.locationActionRequired === 'delivery'){
                        southD = southD + 1
                    }
                }
                if(_location.address.zone === 'North'){
                    if(_location.locationActionRequired === 'pickup'){
                        northP = northP + 1
                    }
                    if(_location.locationActionRequired === 'delivery'){
                        northD = northD + 1
                    }
                }
                if(_location.address.zone === 'West'){
                    if(_location.locationActionRequired === 'pickup'){
                        westP = westP + 1
                    }
                    if(_location.locationActionRequired === 'delivery'){
                        westD = westD + 1
                    }
                }
            })

            let container = {
                eastPickup : eastP,
                eastDelivery : eastD,
                centralPickup : centralP,
                centralDelivery : centralD,
                southPickup : southP,
                southDelivery : southD,
                northPickup : northP,
                northDelivery : northD,
                westPickup : westP,
                westDelivery : westD,
            }
            
            counter[index] = container

        })
        return counter
    }

    hotReload = () => {
        
        if(this.state.searchTerm){

           this.handleSearch({})
           setTimeout( this.hotReload, 10000 )
            
        }else{
             
             let [startDate, endDate] = this.state.dateRange
             let start = startDate ? moment(startDate).format('YYYY-MM-DD') : null
             let end = endDate ? moment(endDate).format('YYYY-MM-DD') : null
     
             _searchScheduler({
                search: this.state.searchTerm ? this.state.searchTerm.toString() : "",
                start,
                end,
                showWeekends: this.state.toggleShowWeekend
             })
             .then(res=>{
                
                 const openKeys = this.generateOpenKeys(res.data)
                 const count = this.sectorCounter(res.data)

                 this.setState({
                    openKeys,
                    count,
                    scheduledLocationData: res.data
                 }, ()=>setTimeout( this.hotReload, 10000 ) )

             })

        }

    }

}

export default connect(
	state => ({
		userData: state.user
	})
)(DeliveryTable);

// export default DeliveryTable;


// WEBPACK FOOTER //
// ./src/components/delivery-page/index.js